exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".internal-table-wrapper table{font-family:arial,sans-serif!important;font-size:13px!important;border:1px solid #cdcdcd!important;border-collapse:collapse!important;width:100%!important}.internal-table-wrapper td,.internal-table-wrapper th{text-align:left!important;padding:8px!important}.internal-table-wrapper th:hover{background-color:#efeeee!important;cursor:pointer!important}.internal-table-wrapper tr:nth-child(2n){background-color:#ddd!important}", ""]);

// exports
